import React from 'react';

const assetFiles = [
  'IMG_2947.JPG','IMG_2949.JPG','IMG_2951.JPG','IMG_2952.JPG','IMG_2968.JPG','IMG_2976.JPG',
  'IMG_2984.JPG','IMG_2999.JPG','IMG_3001.JPG','IMG_3003.JPG','IMG_30031.JPG','IMG_3004.JPG',
  'IMG_3008.JPG','IMG_3013.JPG','IMG_3015.JPG','IMG_3017.JPG','IMG_3020.JPG','IMG_3023.JPG',
  'IMG_3024.JPG','IMG_3038.JPG','IMG_3040.JPG','IMG_3041.JPG','IMG_3043.JPG','IMG_3143.JPG'
];

const colors = ['tile-pink','tile-cyan','tile-yellow','tile-violet','tile-green','tile-white'];

const imgs = assetFiles.map((name, i) => ({
  src: process.env.PUBLIC_URL + '/assets/' + name,
  color: colors[i % colors.length],
  layout: (i % 9 === 0) ? 'tile-wide' : (i % 7 === 0) ? 'tile-tall' : ''
}));

const Gallery = () => {
  return (
    <section id="gallery" className="section bg-dark">
      <div className="container">
        <div className="section-head">
          <h2 className="section-title">Gallery</h2>
          <p className="section-sub">Snapshots in sharp tones.</p>
        </div>
        <div className="mosaic">
          {imgs.map((img, i) => (
            <figure key={img.src + i} data-reveal className={`tile reveal-zoom ${img.color} ${img.layout}`}>
              <img alt="Gallery item" src={img.src} loading="lazy" />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
